import { useState } from 'react'
import toast from 'react-hot-toast'
import { StepProps } from '../TimsurveyWizard'
import { timsurveyApi } from '../../../services/api'
import { TimsurveyAllegato } from '../../../types/timsurvey'

export default function StepPlanimetriaNote({ pratica, form, setForm, onNext, onBack }: StepProps) {
  const [allegati, setAllegati] = useState<TimsurveyAllegato[]>([])
  const [caricando, setCaricando] = useState(false)

  const onFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files
    if (!files || files.length === 0) return
    setCaricando(true)
    try {
      for (const file of Array.from(files)) {
        const res = await timsurveyApi.allegati.upload(pratica.id, file, 'FOTO')
        setAllegati(prev => [...prev, res.data as TimsurveyAllegato])
      }
    } catch (err: any) {
      toast.error(err.response?.data?.detail ?? 'Errore caricamento allegato')
    } finally {
      setCaricando(false)
      e.target.value = ''
    }
  }

  const eliminaAllegato = async (allegato: TimsurveyAllegato) => {
    try {
      await timsurveyApi.allegati.delete(pratica.id, allegato.id)
      setAllegati(prev => prev.filter(a => a.id !== allegato.id))
    } catch {
      toast.error('Errore eliminazione allegato')
    }
  }

  return (
    <div className="card p-4 space-y-3">
      <div>
        <label className="label">Planimetria / foto schema cablaggio</label>
        <input
          type="file"
          accept="image/*,.pdf"
          capture="environment"
          multiple
          disabled={caricando}
          onChange={onFileChange}
        />
      </div>

      {allegati.length > 0 && (
        <div className="space-y-1">
          {allegati.map(a => (
            <div key={a.id} className="flex items-center justify-between text-sm border-b border-slate-50 pb-1">
              <span>{a.filename_originale ?? a.id}</span>
              <button className="text-red-600" onClick={() => eliminaAllegato(a)}>Elimina</button>
            </div>
          ))}
        </div>
      )}

      <div>
        <label className="label">Note aggiuntive ed eventuali criticità</label>
        <textarea
          className="input w-full"
          rows={4}
          value={form.note_aggiuntive}
          onChange={e => setForm(f => ({ ...f, note_aggiuntive: e.target.value }))}
        />
      </div>

      <div className="flex gap-2">
        <button className="btn-secondary" onClick={onBack}>Indietro</button>
        <button className="btn-primary flex-1" onClick={onNext}>Avanti</button>
      </div>
    </div>
  )
}
